// сафари не переваривает специфические форматы

// превращает 2022-01-01 в 01.01.2022
const formateDate = date => {
  if (!date) return '__.__.____';
  const parts = date.split('-');
  if(!parts[2]) return parts[0];
  return `${parts[2]}.${parts[1]}.${parts[0]}`;
};

export default formateDate;
